import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './shared/components/header/header';
import { FooterComponent } from './shared/components/footer/footer';
import { AlertComponent } from './shared/components/alert/alert';
import { CookieConsentComponent } from './shared/components/cookie-consent/cookie-consent';
import { environment } from 'environments/environment';
import Clarity from '@microsoft/clarity';
import { filter } from 'rxjs';
import { clarityInitialized, setClarityInitialized } from './shared/utils/clarity-state';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, FooterComponent, AlertComponent, CookieConsentComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {

  private router = inject(Router);

  ngOnInit(): void {
    // Initialize Clarity only once and only if consent has been given
    if (environment.clarityId && !clarityInitialized()) {
      const consent = localStorage.getItem('cookie_consent');
      if (consent) {
        const prefs = JSON.parse(consent);
        if (prefs.analytics) {
          Clarity.init(environment.clarityId);
          setClarityInitialized(true);
        }
      }
    }
    
    // Listen to route changes and scroll to top (but not for fragment navigation)
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      // Skip scroll-to-top if navigating to a fragment (anchor link)
      if (event.urlAfterRedirects.includes('#')) {
        return;
      }
      // Brute force method to scroll to top as built in Angular functions don't work
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  }

}
